/**
 * クライアントに埋め込まれる環境変数。
 *
 * `VITE_` プレフィックスの値はビルド成果物に平文で載る。
 * ここに秘密情報を足してはいけない(→ docs/guides/environment-variables.md)。
 */

function required(name: string, value: string | undefined): string {
  if (value === undefined || value === "") {
    throw new Error(`環境変数 ${name} が設定されていません`);
  }
  return value;
}

export const env = {
  supabaseUrl: required("VITE_SUPABASE_URL", import.meta.env.VITE_SUPABASE_URL),
  supabaseAnonKey: required("VITE_SUPABASE_ANON_KEY", import.meta.env.VITE_SUPABASE_ANON_KEY),
} as const;
